import Page from '../../../../../shared/components/PageWrapper'

import { FC } from 'react'

const HobbiesPage: FC = () => {
  return <Page children={undefined} />
}

export default HobbiesPage
